import { useEffect } from 'react';
import BasicDataTable from '../../DataTable/BasicDataTable';
import { useEnabledDocumentTypes } from '../../../hooks/dte/useEnabledDocumentTypes';
import EnabledDocumentTypePopup from './EnabledDocumentTypePopup';

const EnabledDocumentTypesTable: React.FC = () => {
  const {
    enabledDocuments,
    fetchEnabledDocuments,
    toggleDocument,

    // modal + form
    isCreateModalOpen,
    openModalCreate,
    closeModalCreate,
  } = useEnabledDocumentTypes();

  // Load on mount
  useEffect(() => {
    fetchEnabledDocuments();
  }, []);

  // Utilidad para formatear la fecha
  const formatDate = (dateStr: string) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-SV', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  // Table columns
  const columns = [
    { Header: 'Documento', accessor: 'documentName' },

    {
      Header: 'Fecha de Habilitación',
      accessor: 'enabledAt',
      Cell: ({ value }: { value: string }) => (
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {formatDate(value)}
        </span>
      ),
    },

    {
      Header: 'Estado',
      accessor: 'enabled',
      Cell: ({ value }: { value: boolean }) => (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            value ? 'bg-green-500 text-white' : 'bg-red text-white'
          }`}
        >
          {value ? 'Habilitado' : 'Deshabilitado'}
        </span>
      ),
    },
  ];

  // Actions for each row
  const actions = [
    {
      key: 'toggle',
      onClick: (row: any) => toggleDocument(row.id),
    },
  ];

  // Header button
  const addButton = (
    <button
      className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
      onClick={openModalCreate}
    >
      + Habilitar Documento
    </button>
  );

  return (
    <>
      <BasicDataTable
        columns={columns}
        data={enabledDocuments}
        noDataMessage="No hay documentos habilitados."
        actions={actions}
        headerButton={addButton}
      />

      {/* Modal para habilitar documento */}
      <EnabledDocumentTypePopup
        isOpen={isCreateModalOpen}
        close={closeModalCreate}
      />
    </>
  );
};

export default EnabledDocumentTypesTable;
